import React from 'react';
import './Checkbox.css';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id?: string;
  name?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  hintClassName?: string;
}

/**
 * Reusable Checkbox component with label and hint support
 */
const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  checked = false,
  onChange,
  label,
  hint,
  disabled = false,
  className = '',
  labelClassName = '',
  hintClassName = '',
  ...rest
}) => {
  const checkboxId = id || name || `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  
  const checkboxElement = (
    <input
      id={checkboxId}
      name={name}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={`common-checkbox ${className}`.trim()}
      {...rest}
    />
  );

  if (label || hint) {
    const labelClass = disabled 
      ? `common-checkbox-label disabled ${labelClassName}`.trim()
      : `common-checkbox-label ${labelClassName}`.trim();
    
    return (
      <div className="common-checkbox-wrapper">
        <label htmlFor={checkboxId} className={labelClass}>
          {checkboxElement}
          {label && <span className="common-checkbox-label-text">{label}</span>}
        </label>
        {hint && (
          <small className={`common-checkbox-hint ${hintClassName}`.trim()}>
            {hint}
          </small>
        )}
      </div>
    );
  }

  return checkboxElement;
};

export default Checkbox;

